import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Hand = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M4.175 2.29375C4.175 2.1731 4.15124 2.05363 4.10506 1.94216C4.05889 1.83069 3.99122 1.72941 3.9059 1.6441C3.82059 1.55878 3.71931 1.49111 3.60784 1.44494C3.49637 1.39876 3.3769 1.375 3.25625 1.375C3.1356 1.375 3.01613 1.39876 2.90466 1.44494C2.79319 1.49111 2.69191 1.55878 2.6066 1.6441C2.52128 1.72941 2.45361 1.83069 2.40744 1.94216C2.36126 2.05363 2.3375 2.1731 2.3375 2.29375V4.04375M4.21875 5.75L4.175 2.29375V1.41875C4.175 1.17508 4.2718 0.941395 4.4441 0.769096C4.61639 0.596797 4.85008 0.5 5.09375 0.5C5.33742 0.5 5.57111 0.596797 5.7434 0.769096C5.9157 0.941395 6.0125 1.17508 6.0125 1.41875V2.29375M2.3375 4.04375C2.3375 3.80008 2.2407 3.56639 2.0684 3.3941C1.89611 3.2218 1.66242 3.125 1.41875 3.125C1.17508 3.125 0.941395 3.2218 0.769096 3.3941C0.596797 3.56639 0.5 3.80008 0.5 4.04375V8.8125C0.5 9.85679 0.914843 10.8583 1.65327 11.5967C2.39169 12.3352 3.39321 12.75 4.4375 12.75H5.61467C6.42685 12.7499 7.20574 12.4272 7.78 11.8528L8.79033 10.8425C9.36469 10.2682 9.6874 9.48935 9.6875 8.67717L9.68925 7.4965C9.68982 7.39323 9.73136 7.29441 9.80475 7.22175C9.89009 7.13641 9.95778 7.0351 10.004 6.9236C10.0501 6.81211 10.0739 6.6926 10.0739 6.57192C10.0739 6.45123 10.0501 6.33173 10.004 6.22023C9.95778 6.10873 9.89009 6.00742 9.80475 5.92208C9.71941 5.83675 9.6181 5.76905 9.5066 5.72287C9.3951 5.67668 9.2756 5.65291 9.15492 5.65291C9.03423 5.65291 8.91473 5.67668 8.80323 5.72287C8.69173 5.76905 8.59042 5.83675 8.50508 5.92208C8.08885 6.33777 7.85398 6.90125 7.85175 7.4895M2.3375 4.04375V6.625M6.0125 2.29375V6.1875M6.0125 2.29375C6.0125 2.05008 6.1093 1.81639 6.2816 1.6441C6.45389 1.4718 6.68758 1.375 6.93125 1.375C7.17492 1.375 7.4086 1.4718 7.5809 1.6441C7.7532 1.81639 7.85 2.05008 7.85 2.29375V8.375M7.85117 8.375H7.85C7.50543 8.37483 7.16421 8.44266 6.84589 8.57459C6.52758 8.70652 6.23843 8.89996 5.995 9.14383" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="outline" viewBox="0 0 11 14" strokeWidth={0.9}>{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { Hand };